// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaFacebookF, FaTwitter, FaInstagram, FaYoutube } from 'react-icons/fa';
import { MdMosque } from 'react-icons/md';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Footer Wave Decoration */}
      <div className="footer-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#2d4e3aff" fillOpacity="1" d="M0,224L48,213.3C96,203,192,181,288,186.7C384,192,480,224,576,213.3C672,203,768,149,864,128C960,107,1056,117,1152,122.7C1248,128,1344,128,1392,128L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
      
      {/* Main Footer Content */}
      <div className="footer-content">

        {/* Quick Links Column */}
        <div className="footer-column">
          <h4 className="footer-title">Liens Rapides</h4>
          <ul className="footer-links">
            <li><Link to="/">Accueil</Link></li>
            <li><Link to="/about">À Propos de Nous</Link></li>
            <li><Link to="/admissions">Admissions</Link></li>
            <li><Link to="/contact">Contactez nous</Link></li>
          </ul>
        </div>
        
        {/* Contact Info Column */}
        <div className="footer-column">
          <h4 className="footer-title">Contactez-Nous</h4>
          <ul className="footer-contact">
            <li>
              <FaMapMarkerAlt className="contact-icon" />
              <span>Campus Thies</span>
            </li>
            <li>
              <FaPhone className="contact-icon" />
              <span>+221 70 686 36 36</span>
            </li>
            <li>
              <FaEnvelope className="contact-icon" />
              <span>u2s.edu@gmail.com</span>
            </li>
          </ul>
        </div>
        
        {/* Newsletter Column */}
        <div className="footer-column">
          <h4 className="footer-title">Bulletin d'Information</h4>
          <p className="newsletter-text">
            Inscrivez-vous pour recevoir les dernières actualités de notre école et les événements à venir.
          </p>
          <form className="newsletter-form">
            <input 
              type="email" 
              placeholder="Votre adresse email" 
              required 
            />
            <button type="submit">S'inscrire</button>
          </form>
          

        </div>
      </div>
      
      {/* Copyright Section */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>
            &copy; {new Date().getFullYear()} Université des Sciences de Sebikotane. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;